import { render } from "./system-management.vue?vue&type=template&id=42d14ca4&ts=true"
import script from "./system-management.vue?vue&type=script&lang=ts"
export * from "./system-management.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__